"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.EDIT_TYPE = exports.ELEMENT_TYPE = exports.GUIDE_TYPE = exports.RENDER_STATE = exports.RENDER_TYPE = exports.SHAPE = exports.GEOJSON_TYPE = void 0;
var GEOJSON_TYPE;
exports.GEOJSON_TYPE = GEOJSON_TYPE;

(function (GEOJSON_TYPE) {
  GEOJSON_TYPE["POINT"] = "Point";
  GEOJSON_TYPE["LINE_STRING"] = "LineString";
  GEOJSON_TYPE["POLYGON"] = "Polygon";
})(GEOJSON_TYPE || (exports.GEOJSON_TYPE = GEOJSON_TYPE = {}));

var SHAPE;
exports.SHAPE = SHAPE;

(function (SHAPE) {
  SHAPE["POINT"] = "Point";
  SHAPE["LINE_STRING"] = "LineString";
  SHAPE["POLYGON"] = "Polygon";
  SHAPE["RECTANGLE"] = "Rectangle";
  SHAPE["CIRCLE"] = "Circle";
})(SHAPE || (exports.SHAPE = SHAPE = {}));

var RENDER_TYPE;
exports.RENDER_TYPE = RENDER_TYPE;

(function (RENDER_TYPE) {
  RENDER_TYPE["POINT"] = "Point";
  RENDER_TYPE["LINE_STRING"] = "LineString";
  RENDER_TYPE["POLYGON"] = "Polygon";
  RENDER_TYPE["RECTANGLE"] = "Rectangle";
})(RENDER_TYPE || (exports.RENDER_TYPE = RENDER_TYPE = {}));

var RENDER_STATE;
exports.RENDER_STATE = RENDER_STATE;

(function (RENDER_STATE) {
  RENDER_STATE["INACTIVE"] = "INACTIVE";
  RENDER_STATE["UNCOMMITTED"] = "UNCOMMITTED";
  RENDER_STATE["SELECTED"] = "SELECTED";
  RENDER_STATE["HOVERED"] = "HOVERED";
  RENDER_STATE["CLOSING"] = "CLOSING";
})(RENDER_STATE || (exports.RENDER_STATE = RENDER_STATE = {}));

var GUIDE_TYPE;
exports.GUIDE_TYPE = GUIDE_TYPE;

(function (GUIDE_TYPE) {
  GUIDE_TYPE["TENTATIVE"] = "tentative";
  GUIDE_TYPE["EDIT_HANDLE"] = "editHandle";
  GUIDE_TYPE["CURSOR_EDIT_HANDLE"] = "cursorEditHandle";
})(GUIDE_TYPE || (exports.GUIDE_TYPE = GUIDE_TYPE = {}));

var ELEMENT_TYPE;
exports.ELEMENT_TYPE = ELEMENT_TYPE;

(function (ELEMENT_TYPE) {
  ELEMENT_TYPE["FEATURE"] = "feature";
  ELEMENT_TYPE["FILL"] = "fill";
  ELEMENT_TYPE["SEGMENT"] = "segment";
  ELEMENT_TYPE["EDIT_HANDLE"] = "editHandle";
})(ELEMENT_TYPE || (exports.ELEMENT_TYPE = ELEMENT_TYPE = {}));

var EDIT_TYPE;
exports.EDIT_TYPE = EDIT_TYPE;

(function (EDIT_TYPE) {
  EDIT_TYPE["ADD_FEATURE"] = "addFeature";
  EDIT_TYPE["ADD_POSITION"] = "addPosition";
  EDIT_TYPE["REMOVE_POSITION"] = "removePosition";
  EDIT_TYPE["MOVE_POSITION"] = "movePosition";
  EDIT_TYPE["FINISH_MOVE_POSITION"] = "finishMovePosition";
})(EDIT_TYPE || (exports.EDIT_TYPE = EDIT_TYPE = {}));
//# sourceMappingURL=data:application/json;charset=utf-8;base64,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